/** @format */

import { KeyValue } from '@angular/common';
import { SEOTabContent } from './seo-tab-content.interface';

export interface SanitizedSEOAttributes {
  seoTabsContent: SEOTabContent[];
  seoFeaturedLinks: KeyValue<string, string>[];
  sdxIncludesSuppressFlag: string;
  seoRobotsNoIndex: string;
  seoKeywords: string;
  sponsoredProducts: string;
  layoutType: string;
  pageType: string;
  metaDescription: string;
  seoRobotsNoFollow: string;
  breadcrumb: string;
  seoNotes: string;
  seoHypercatSuppress: string;
  defaultLinkText: string;
  seoHeadline: string;
  layoutPriority: string;
  topResultThumbnail: string;
  title: string;
  seoCanonical: string;
  layoutOption: string;
  topResultFullImage: string;
}
